module.exports = __webpack_public_path__ + "static/media/youtube.c80bd941.svg";